module.exports = __webpack_public_path__ + "static/media/background2.8c01c3f8.jpg";